// extracted by mini-css-extract-plugin
export default {"root":"SubCard_root__ywozg"};